import { SagaReturnType, call, put, takeEvery } from 'redux-saga/effects';
import { monthCloseOutAlertConstants } from '../../actions/constant';
import monthlyCloseoutService from 'src/services/apiServices/monthlyCloseOut/monthlyCloseoutService';

const {
  UPLOAD_MONTH_END_ALERT_SIGN_REQUEST,
  UPLOAD_MONTH_END_ALERT_SIGN_SUCCESS,
  UPLOAD_MONTH_END_ALERT_SIGN_FAILURE,
  UPLOAD_MONTH_END_ALERT_SIGN_LOADING,
  UPLOAD_MONTH_END_ALERT_SIGN_RESET,
} = monthCloseOutAlertConstants;
function* uploadSignatureFile(action: any): SagaReturnType<any> {
  try {
    yield put({ type: UPLOAD_MONTH_END_ALERT_SIGN_LOADING });
    const response = yield call(monthlyCloseoutService.uploadSignatureFile, action.payload);

    if (response?.status === 200) {
      yield put({ type: UPLOAD_MONTH_END_ALERT_SIGN_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: UPLOAD_MONTH_END_ALERT_SIGN_FAILURE, payload: error });
  }
}

function* uploadSignatureFileSaga() {
  yield takeEvery(UPLOAD_MONTH_END_ALERT_SIGN_REQUEST, uploadSignatureFile);
}

export default uploadSignatureFileSaga;
